import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getCompanies, selectCompany, setCompaniesFilters } from '../store/actions/companiesActions';
import { toggleModal} from '../store/actions/toggleModalActions';
import './Companies.scss';

import Spinner from './_common/Spinner';
import List from './_common/List';
import CompanyModal from './CompanyModal';

const selector = state => {
    const { language, companies, modalState } = state;
    return {
    t: language.translator,
    pending: companies.pending,
    companies: companies.companies,
    page: companies.page,
    pageCount: companies.pageCount,
    itemsCount: companies.itemsCount,
    selected: companies.selected,
    filters: companies.filters,
    modalState: modalState,
    }
};

const Companies = () => {
    const { t, pending, companies, page, pageCount, itemsCount, modalState, selected, filters } = useSelector(selector);
    const dispatch = useDispatch();
    const [filter, setFilter] = useState('ALL');
    const [search, setSearch] = useState('');

    useEffect(() => {
        dispatch(setCompaniesFilters({active: 'ALL', itemsPerPage: 10, search: ''}))
        dispatch(getCompanies(1, 10, filter, '', ''));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='companies'>
            <div className='companiesHeader'>
                <form className='companiesFilter'>
                    <input
                        type='radio'
                        id='filterActive'
                        checked={filter === 'BLOCKED'}
                        onChange={() => {
                            dispatch(setCompaniesFilters({active: 'BLOCKED', itemsPerPage: 10, search: filters.search}));
                            setFilter('BLOCKED');
                            dispatch(getCompanies(1, 10, 'BLOCKED', filters.search));
                        }}
                    />
                    <label htmlFor='filterActive'>
                        {t.gettext('Blocked')}
                    </label>
                    <input
                        type='radio'
                        id='filterNotActive'
                        checked={filter === 'NOT_BLOCKED'}
                        onChange={() => {
                            dispatch(setCompaniesFilters({active: 'NOT_BLOCKED', itemsPerPage: 10, search: filters.search}));
                            setFilter('NOT_BLOCKED');
                            dispatch(getCompanies(1, 10, 'NOT_BLOCKED', filters.search));
                        }}
                    />
                    <label htmlFor='filterNotActive'>
                        {t.gettext('Not Blocked')}
                    </label>
                    <input
                        type='radio'
                        id='filterAll'
                        checked={filter === 'ALL'}
                        onChange={() => {
                            dispatch(setCompaniesFilters({active: 'ALL', itemsPerPage: 10, search: filters.search}));
                            setFilter('ALL');
                            dispatch(getCompanies(1, 10, 'ALL', filters.search));
                        }}
                    />
                    <label htmlFor='filterAll'>
                        {t.gettext('All')}
                    </label>

                    <div className='searchInputWrapper'>
                        <input
                            type='text'
                            className='companySearchInput'
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                        {filters.search
                            ? <span
                                className='material-icons companySearchCancelButton'
                                onClick={() => {
                                    dispatch(setCompaniesFilters({active: filter, itemsPerPage: 10, search: ''}));
                                    setSearch('');
                                    dispatch(getCompanies(1, 10, filter, ''));
                                }}
                            >
                            cancel
                        </span>
                            : null
                        }
                    </div>
                    <button
                        className='companySearchButton'
                        onClick={e => {
                            e.preventDefault();
                            setFilter('ALL');
                            dispatch(setCompaniesFilters({active: 'ALL', itemsPerPage: 10, search: search}))
                            dispatch(getCompanies(1, 10, 'ALL', search))
                        }}
                        disabled={!search}
                    >
                        {t.gettext('SEARCH')}
                    </button>
                </form>
                <button
                    className='companyAddButton'
                    onClick={e => {
                        e.preventDefault();
                        dispatch(toggleModal(true, 'Add company'));
                    }}
                >
                    <span className='material-icons companyAddButtonIcon'>
                        add
                    </span>
                </button>
            </div>

            <div className={'companiesList'}>
                {pending
                    ? <div className='page'>
                        <Spinner size={300}/>
                    </div>
                    : <List
                        roundTopCorners
                        items={companies}
                        page={page}
                        itemsPerPage={10}
                        pageCount={pageCount}
                        itemsCount={itemsCount}
                        columnsNames={['Name', 'Address', 'VAT Number', 'Is Active']}
                        columns={['name', 'address', 'vatNumber', 'isBlocked']}
                        columnsWidths={['30%', '30%', '30%', '10%']}
                        filter={filter}
                        invertedBooleanColumn={4}
                        getItemsMethod={getCompanies}
                        selectItemMethod={selectCompany}
                        onSelectModalName='Edit company'
                        userId=''
                        search={filters.search}
                    />
                }

                {(modalState.flag && modalState.modal === 'Add company') &&
                    <CompanyModal
                        company={selected.company}
                        numberPerPage={10}
                        filter={filter}
                    />
                }

                {(modalState.flag && modalState.modal === 'Edit company') &&
                    <CompanyModal
                        company={selected.company}
                        numberPerPage={10}
                        filter={filter}
                        edit
                    />
                }
            </div>
        </div>
    );
};

export default Companies;
